import * as nouvelleSouscriptionFormNames from "./nouvelleSouscriptionFormNames";

export const nouvelleSouscriptionInitialValues = {
  [nouvelleSouscriptionFormNames.NOUVELLE_SOUSCRIPTION_EXERCICE_FORM_NAME]: "",
  [nouvelleSouscriptionFormNames.NOUVELLE_SOUSCRIPTION_ACCEPT_TERMS_FORM_NAME]: false,
};
